import axios from 'axios';
class CopyUrlContentToClipboard{
    constructor(){
    }

    async copy(url){
        try {
            const response = await axios.get(url)
            const text = response.data
            navigator.clipboard.writeText(text)

            return true
        } catch (error) {  
            return false  
        } 
    }
}

export default new CopyUrlContentToClipboard()